"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => {
  var _theme$palette, _theme$palette2;
  return {
    label: {
      fontWeight: theme.typography.fontWeightBold
    },
    wrapper: {
      alignItems: "center",
      display: "flex"
    },
    icon: {
      "& svg": {
        height: 20,
        width: 20
      }
    },
    iconEmpty: {
      "& svg": {
        fill: (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.grey) === null || _theme$palette === void 0 ? void 0 : _theme$palette[200]
      }
    },
    iconFilled: {
      "& svg": {
        fill: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 || (_theme$palette2 = _theme$palette2.primary) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.main
      }
    },
    counter: {
      color: theme.palette.text.secondary,
      fontSize: "0.875rem",
      marginLeft: theme.spacing(1)
    }
  };
});
var _default = exports.default = styles;